export enum EnumRole {
  ProductViewer = "product_viewer",
  ProductExplorer = "product_explorer",
  ProductOwner = "product_owner",
}
